/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Processing_HelpInputs */

const en_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption embedding and processing`)
};

const fr_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustation et traitement des sous-titres`)
};

const de_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einbettung und Verarbeitung von Untertiteln`)
};

const it_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporamento ed elaborazione delle didascalie`)
};

const ru_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание и обработка субтитров`)
};

const es_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporación y procesamiento de subtítulos`)
};

const zh_cn2_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕嵌入和处理`)
};

const ja_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションの埋め込みと処理`)
};

const hi_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन एम्बेडिंग और प्रोसेसिंग`)
};

const pt_pt2_embed_captions_pricing_processing_help = /** @type {(inputs: Embed_Captions_Pricing_Processing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporação e processamento de legendas`)
};

/**
* | output |
* | --- |
* | "Caption embedding and processing" |
*
* @param {Embed_Captions_Pricing_Processing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_processing_help = /** @type {((inputs?: Embed_Captions_Pricing_Processing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Processing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_pricing_processing_help(inputs)
	if (locale === "de") return de_embed_captions_pricing_processing_help(inputs)
	if (locale === "it") return it_embed_captions_pricing_processing_help(inputs)
	if (locale === "ru") return ru_embed_captions_pricing_processing_help(inputs)
	if (locale === "es") return es_embed_captions_pricing_processing_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_pricing_processing_help(inputs)
	if (locale === "ja") return ja_embed_captions_pricing_processing_help(inputs)
	if (locale === "hi") return hi_embed_captions_pricing_processing_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_pricing_processing_help(inputs)
	return en_embed_captions_pricing_processing_help(inputs)
});